import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Luciano Barber Shop';
render(<App data-id="element-281" />, document.getElementById('root'));